import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSizer } from "../redux/Action/Sizer/sizer";
import { programHistory } from "../redux/Action/Sizer/addProgram";
import { getCompanyId } from "../helper/utils/companyId";

export function useSizerData() {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const companyId = getCompanyId();

  useEffect(() => {
    if (companyId && token) {
      dispatch(getSizer(companyId, token));
      dispatch(programHistory(companyId, token));
    }
  }, [companyId, token, dispatch]);
}

export function parseSizerRates(sizer) {
  if (!sizer) return [];
  const raw = sizer.sizer_quality_rate;
  if (Array.isArray(raw)) return raw;
  if (typeof raw === "string") {
    try {
      return JSON.parse(raw);
    } catch (e) {
      return [];
    }
  }
  return [];
}
